export const RUBRIQUES = [
  {
  id: "infos_enfant",
  label: "Informations de l'enfant",
  path: "/dossier/:id",
  },
  {
  id: "infos_references",
  label: "Informations sur les Références",
  path: "/dossier/:id/references",
  },
  { id: "infos_generales",  label: "Informations Générales", path: "/dossier/:id/generales" },
  { id: "observations_malade",  label: "Observation du Malade",   path: "/dossier/:id/observations" },
  { id: "cartographie_sites",    label: "Cartographie des Sites Tumoraux", path: "/dossier/:id/cartographie" },
  { id: "resultats_bilan",       label: "Résultats du Bilan Initial",      path: "/dossier/:id/resultats-bilan" },
  { id: "conclusion_cartographie_site", label: "Conclusion – Cartographie des Sites", path: "/dossier/:id/conclusion-cartographie" },
  { id: "decision_therapeutique", label: "Décision Thérapeutique", path: "/dossier/:id/decision-therapeutique" },
  { id: "evaluation_pathologie", label: "Évaluation Pathologie", path: "/dossier/:id/evaluation-pathologie" },
  { id: "traitement_deuxieme_ligne", label: "Traitement 2ème Ligne", path: "/dossier/:id/traitement-deuxieme-ligne" },
  { id: "premiere_hospitalisation", label: "1ère Hospitalisation", path: "/dossier/:id/premiere-hospitalisation" },
  { id: "nouvelle_hospitalisation", label: "Nouvelle Hospitalisation", path: "/dossier/:id/nouvelle-hospitalisation" },
  { id: "dernieres_nouvelles", label: "Dernières Nouvelles", path: "/dossier/:id/dernieres-nouvelles" },
  { id: "courbe_croissance", label: "Courbe de Croissance", path: "/dossier/:id/courbe-croissance" },
  { id: "pages_annexes",    label: "Pages Annexes",    path: "/dossier/:id/pages-annexes" },
  { id: "examens_medicaux", label: "Examens Médicaux",  path: "/dossier/:id/examens-medicaux" },
  { id: "galerie", label: "Galerie Photos", path: "/dossier/:id/galerie" },
];

